import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/features/public/NotFound";

export const Route = createFileRoute("/app/$")({
  component: () => <NotFound inShell />,
});
